import { Button, InlineAlert } from '@lego/connect-components-react';
import { useTranslation } from 'react-i18next';
import { useAssistantChat } from '../../hooks/use-assistant-chat';
import { MessageInput } from './message-input';
import { MessageList } from './message-list';

export const ChatWindow = () => {
  const { t } = useTranslation();
  const { messages, send, isLoading, error, reset } = useAssistantChat();

  const errorText =
    error?.type === 'unauthorized'
      ? t('assistant.response.sessionExpired')
      : (error?.message ?? t('assistant.response.error'));

  return (
    <div className="flex flex-col max-sm:h-full max-sm:min-h-0 max-sm:justify-end">
      <div className="flex min-h-0 flex-col gap-300">
        <div className="min-h-0 max-h-[24rem] overflow-y-auto pr-[20px] max-sm:max-h-none">
          <MessageList messages={messages} isLoading={isLoading} />
        </div>

        {error && (
          <InlineAlert variant="warning">
            <InlineAlert.Title>{errorText}</InlineAlert.Title>
          </InlineAlert>
        )}

        <div className="flex shrink-0 flex-col gap-200 max-sm:pb-200">
          <MessageInput onSend={send} disabled={isLoading} />
          {messages.length > 0 && (
            <Button
              variant="neutral"
              appearance="ghost"
              size="small"
              onClick={reset}
              className="self-end"
            >
              {t('assistant.action.clear')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
